//------------------------------------------------------------------------------
// メニュー状態 アクション
//------------------------------------------------------------------------------
import types from './types';

/**
 * メニュー項目展開状態
 */
export const setExpandedItems = (itemIds) => {
  return {
    type: types.EXPANDED_ITEMS,
    expandedItems: itemIds,
  };
}
